import { z } from 'zod';

export enum AssetType {
  CONTAINER = 'BESS',
  STRING = 'String',
  RACK = 'Rack',
  MODULE = 'Module',
  PCS = 'PCS',
}

export const AssetTypeSchema = z.nativeEnum(AssetType);
